import React, { useMemo } from "react";
import Select from "../../../form/select/Select";

const Account = ({
  p_account_info,
  values,
  errors,
  edit,
  gl_accounts,
  setFieldValue,
}) => {
  return (
    <>
      <h5 className='text-primary-1 mt-2'>ACCOUNT GL</h5>
      {!edit ? (
        <div className='row'>
          {p_account_info?.income_gl ? (
            <div className='col-md-3'>
              <label
                htmlFor='policy_name'
                className='form-label text-capitalize'
              >
                Income GL
              </label>
              <p>
                {
                  gl_accounts?.accounts?.income_account?.filter(
                    (income) =>
                      income.id === parseInt(p_account_info?.income_gl)
                  )[0]?.account_name
                }
              </p>
            </div>
          ) : null}
          {p_account_info?.expense_gl ? (
            <div className='col-md-3'>
              <label
                htmlFor='policy_name'
                className='form-label text-capitalize'
              >
                Commission
              </label>
              <p>
                {
                  gl_accounts?.accounts?.expense_account?.filter(
                    (expense) =>
                      expense.id === parseInt(p_account_info?.expense_gl)
                  )[0]?.account_name
                }
              </p>
            </div>
          ) : null}
          {p_account_info?.interest_expense_gl ? (
            <div className='col-md-3'>
              <label
                htmlFor='policy_name'
                className='form-label text-capitalize'
              >
                Interest Expense
              </label>
              <p>
                {
                  gl_accounts?.accounts?.expense_account?.filter(
                    (expense) =>
                      expense.id === parseInt(p_account_info?.interest_expense_gl)
                  )[0]?.account_name
                }
              </p>
            </div>
          ) : null}
          {p_account_info?.asset_gl ? (
            <div className='col-md-3'>
              <label
                htmlFor='policy_name'
                className='form-label text-capitalize'
              >
                Asset GL
              </label>
              <p>
                {
                  gl_accounts?.accounts?.asset_account?.filter(
                    (asset) => asset.id === parseInt(p_account_info?.asset_gl)
                  )[0]?.account_name
                }
              </p>
            </div>
          ) : null}
          {p_account_info?.liability_gl ? (
            <div className='col-md-3'>
              <label
                htmlFor='policy_name'
                className='form-label text-capitalize'
              >
                Policy Portfolio
              </label>
              <p>
                {
                  gl_accounts?.accounts?.liability_account?.filter(
                    (liability) =>
                      liability.id === parseInt(p_account_info?.liability_gl)
                  )[0]?.account_name
                }
              </p>
            </div>
          ) : null}
          {p_account_info?.provision_gl ? (
            <div className='col-md-3'>
              <label
                htmlFor='policy_name'
                className='form-label text-capitalize'
              >
                Provision GL
              </label>
              <p>
                {
                  gl_accounts?.accounts?.provision_account?.filter(
                    (provision) =>
                      provision.id === parseInt(p_account_info?.provision_gl)
                  )[0]?.account_name
                }
              </p>
            </div>
          ) : null}
          {p_account_info?.tax_gl ? (
            <div className='col-md-3'>
              <label
                htmlFor='policy_name'
                className='form-label text-capitalize'
              >
                Tax GL
              </label>
              <p>
                {
                  gl_accounts?.accounts?.tax_account?.filter(
                    (tax) => tax.id === parseInt(p_account_info?.tax_gl)
                  )[0]?.account_name
                }
              </p>
            </div>
          ) : null}
        </div>
      ) : (
        <div className='col-md-'>
          <div className='mb-3'>
            <div>
              {errors?.gl && <p className='alert alert-danger'>{errors?.gl}</p>}
            </div>
            <div className='d-flex gap-2  mb-3'>
              <label
                htmlFor=''
                className='form-label my-auto'
                style={{ width: "125px" }}
              >
                Income GL 1
              </label>
              <div style={{ width: "100%" }}>
                <Select
                  name='income_gl'
                  data={gl_accounts?.accounts?.income_account?.map((item) => ({
                    label: item?.account_name,
                    value: item?.id,
                  }))}
                  defaultValue={p_account_info?.income_gl}
                  //   value={values.income_gl || p_account_info?.income_gl}
                  onChange={(selectedOption) =>
                    setFieldValue("income_gl", selectedOption?.value)
                  }
                />
                {errors?.income_gl && (
                <p className='mb-0 text-danger'>
                    {errors?.income_gl + '*'}
                </p>
                )}
              </div>
            </div>
          </div>
          <div className='mb-3'>
            <div className='d-flex gap-2 d-col mb-3'>
              <label
                htmlFor=''
                className='form-label my-auto'
                style={{ width: "125px" }}
              >
                Commission
              </label>
              <div style={{ width: "100%" }}>
                <Select
                  name='expense_gl'
                  data={gl_accounts?.accounts?.expense_account?.map((item) => ({
                    label: item?.account_name,
                    value: item?.id,
                  }))}
                  defaultValue={p_account_info?.expense_gl}
                  value={values.expense_gl}
                  onChange={(selectedOption) =>
                    setFieldValue("expense_gl", selectedOption?.value)
                  }
                />
              </div>
            </div>
          </div>
          <div className='mb-3'>
            <div className='d-flex gap-2 d-col mb-3'>
              <label
                htmlFor=''
                className='form-label my-auto'
                style={{ width: "125px" }}
              >
                Interest Expense
              </label>
              <div style={{ width: "100%" }}>
                <Select
                  name='interest_expense_gl'
                  data={gl_accounts?.accounts?.expense_account?.map((item) => ({
                    label: item?.account_name,
                    value: item?.id,
                  }))}
                  defaultValue={p_account_info?.interest_expense_gl}
                  value={values.interest_expense_gl}
                  onChange={(selectedOption) =>
                    setFieldValue("interest_expense_gl", selectedOption?.value)
                  }
                />
                {errors?.interest_expense_gl && (
                <p className='mb-0 text-danger'>
                    {errors?.interest_expense_gl + '*'}
                </p>
                )}
              </div>
            </div>
          </div>
          <div className='mb-3'>
            <div className='d-flex gap-2 d-col mb-3'>
              <label
                htmlFor=''
                className='form-label my-auto'
                style={{ width: "125px" }}
              >
                Asset GL 1
              </label>
              <div style={{ width: "100%" }}>
                <Select
                  name='asset_gl'
                  data={gl_accounts?.accounts?.asset_account?.map((item) => ({
                    label: item?.account_name,
                    value: item?.id,
                  }))}
                  value={values.asset_gl}
                  defaultValue={p_account_info?.asset_gl}
                  onChange={(selectedOption) =>
                    setFieldValue("asset_gl", selectedOption?.value)
                  }
                />
                {errors?.asset_gl && (
                <p className='mb-0 text-danger'>
                    {errors?.asset_gl + '*'}
                </p>
                )}
              </div>
            </div>
          </div>
          <div className='mb-3'>
            <div className='d-flex gap-2 d-col mb-3'>
              <label
                htmlFor=''
                className='form-label my-auto'
                style={{ width: "125px" }}
              >
                Policy Portfolio
              </label>
              <div style={{ width: "100%" }}>
                <Select
                  name='liability_gl'
                  data={gl_accounts?.accounts?.liability_account?.map(
                    (item) => ({
                      label: item?.account_name,
                      value: item?.id,
                    })
                  )}
                  defaultValue={p_account_info?.liability_gl}
                  value={values.liability_gl}
                  onChange={(selectedOption) =>
                    setFieldValue("liability_gl", selectedOption?.value)
                  }
                />
                {errors?.liability_gl && (
                <p className='mb-0 text-danger'>
                    {errors?.liability_gl + '*'}
                </p>
                )}
              </div>
            </div>
          </div>
          <div className='mb-3'>
            <div className='d-flex gap-2 d-col mb-3'>
              <label
                htmlFor=''
                className='form-label my-auto'
                style={{ width: "125px" }}
              >
                Provision GL 1
              </label>
              <div style={{ width: "100%" }}>
                <Select
                  name='provision_gl'
                  data={gl_accounts?.accounts?.provision_account?.map(
                    (item) => ({
                      label: item?.account_name,
                      value: item?.id,
                    })
                  )}
                  defaultValue={p_account_info?.provision_gl}
                  value={values.provision_gl}
                  onChange={(selectedOption) =>
                    setFieldValue("provision_gl", selectedOption?.value)
                  }
                />
              </div>
            </div>
          </div>
          <div className='mb-3'>
            <div className='d-flex gap-2 d-col mb-3'>
              <label
                htmlFor=''
                className='form-label my-auto'
                style={{ width: "125px" }}
              >
                Tax GL 1
              </label>
              <div style={{ width: "100%" }}>
                <Select
                  name='tax_gl'
                  data={gl_accounts?.accounts?.tax_account?.map((item) => ({
                    label: item?.account_name,
                    value: item?.id,
                  }))}
                  defaultValue={p_account_info?.tax_gl}
                  value={values.tax_gl}
                  onChange={(selectedOption) =>
                    setFieldValue("tax_gl", selectedOption?.value)
                  }
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Account;
